import { FC, useState } from 'react';
import { lazyRetryWithSuspense } from '@/helpers/lazyComponents';
import IcoSearch from '@/assets/svg/ico_search.svg?react';
import Button from '@/components/controls/Button/Button.component';
import styles from '@/components/widgets/SearchWidget/SearchWidget.module.scss';
import { SearchWidgetPropsIF } from '@/components/widgets/SearchWidget/SearchWidget.types';

const SearchFilterWidget = lazyRetryWithSuspense(
    () =>
        import('@/components/widgets/SearchWidget/SearchFilterWidget/SearchFilterWidget.component'),
);

const SearchWidget: FC<SearchWidgetPropsIF> = ({
    className,
    isNeedHighlight,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button
                className={`${styles.searchButton} ${className || ''}`}
                dataTest="search_button"
                isCustom
                clickHandler={() => setIsOpen(true)}
            >
                <IcoSearch
                    className={`${styles.icon} ${isNeedHighlight ? 'tourStepSearch' : ''}`}
                />
            </Button>

            {isOpen && (
                <SearchFilterWidget
                    withOverlay
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
};

export default SearchWidget;
